<template>
  <div class="APP-BOX clearfix">
    <div class="top-container">
      <mt-swipe :auto="5000">
        <mt-swipe-item>
          <img src="../../../static/img/ban01.jpg">
        </mt-swipe-item>
        <mt-swipe-item>
          <img src="../../../static/img/ban01.jpg">
        </mt-swipe-item>
        <mt-swipe-item>
          <img src="../../../static/img/ban01.jpg">
        </mt-swipe-item>
      </mt-swipe>

      <div class="banner">
        <ul class="tagsa">
          <router-link to="/scheduler/all" tag="li" active-class="selectTaga">
            全部
          </router-link>
          <router-link to="/scheduler/applying" tag="li">
            申请中
          </router-link>
          <router-link to="/scheduler/waiting" tag="li">
            待做
          </router-link>
          <router-link to="/scheduler/notArrangement" tag="li">
            未排上
          </router-link>
          <router-link to="/scheduler/done" tag="li">
            已做
          </router-link>
          <div class="clear"></div>
        </ul>
      </div>
    </div>

    <div class="scheduler-list">
      <transition>
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  //import Vue from 'vue'
  import {Swipe, SwipeItem} from 'mint-ui'

  Vue.component(Swipe.name, Swipe)
  Vue.component(SwipeItem.name, SwipeItem)

  export default {
    data () {
      return {}
    },
    methods: {}
  }
</script>

<style lang="scss" scoped>
  .mint-swipe {
    height: 130px;

    .mint-swipe-item {
      img {
        width: 100%;
        height: 100%;
      }
    }

  }

  .top-container {
    position: fixed;
    width: 100%;
    z-index: 1000;
  }

  .scheduler-list {
    padding-top: 170px;
  }

  .v-enter {
    opacity: 0;
    transform: translateX(100%);
  }

  .v-leave-to {
    opacity: 0;
    transform: translateX(-100%);
    position: absolute;
  }

  .v-enter-active,
  .v-leave-active {
    transition: all 0.5s ease;
  }
</style>



// WEBPACK FOOTER //
// src/pages/scheduler/Scheduler.vue